export const authUtils = {
    // 获取 token
    getToken() {
        return localStorage.getItem('auth_token');
    },
    // 设置 token
    setToken(token) {
        localStorage.setItem('auth_token', token);
    },
    // 移除 token
    removeToken() {
        localStorage.removeItem('auth_token');
    },
    // 检查是否已登录
    isLoggedIn() {
        const token = this.getToken();
        return !!token;
    },
    // 清除所有认证信息
    clearAuth() {
        this.removeToken();
        // 可以在这里清除其他相关的用户信息
    }
};
export default authUtils;
